export default "__VITE_ASSET__rw9FYmc7__"